export default __webpack_public_path__ + "img/component-info-card.d19a4464.png";